export class DtoApiError {
  public message: string | null = null;
  public info: string | null = null;
  public logStream: string = "ls";
}
